import React from 'react';
import './Phase3.css';
import { POINT_SYSTEM } from '../../constants';
import MatchComponent from '../MatchComponent/MatchComponent';
import Button from '../../../../components/Button/Button';
import PointSummary from '../PointSummary/PointSummary';

const Phase3 = ({ 
  finalPrediction, 
  onFinalPredictionChange, 
  realResults = {},
  phaseLocks = {},
  savedGuesses = {},
  onSaveGroupGuess,
  preseasonWinner = ''
}) => {
  // Hent finale holdene fra databasen (realResults) eller brug fallback
  const getFinalMatchup = () => {
    if (realResults?.finalResult && realResults.finalResult.home && realResults.finalResult.away) {
      return {
        home: realResults.finalResult.home,
        away: realResults.finalResult.away,
        id: realResults.finalResult.id || 'final'
      };
    }
    // Fallback hvis finalen ikke er sat op endnu
    return {
      home: 'TBD',
      away: 'TBD',
      id: 'final'
    };
  };

  const finalMatch = getFinalMatchup();
  const isPhase3Locked = phaseLocks.phase3 || false;
  const isFinalPredictionSaved = savedGuesses.phase3 || false;
  const hasFinalPrediction = finalPrediction && finalPrediction !== '';
  
  // Tjek om Phase0 gættet er i finalen
  const isPreseasonWinnerInFinal = preseasonWinner && (
    preseasonWinner === finalMatch.home || 
    preseasonWinner === finalMatch.away
  );

  return (
    <div className="phase-container">
      <h3>Fase 3 - Finalen</h3>
      <p>Gæt vinderen af finalen:</p>
      
      {isFinalPredictionSaved && (
        <div className="save-status">
          <p>✅ <strong>Finale gæt gemt!</strong></p>
        </div>
      )}
      
      {preseasonWinner && (
        <div className={`preseason-info ${isPreseasonWinnerInFinal ? 'in-final' : 'not-in-final'}`}>
          {isPreseasonWinnerInFinal ? (
            <p className="bonus-info">
              ✅ Du har gættet på {preseasonWinner} som vinder af Champions League 25/26 i fase 0 og de er i finalen! Hvis {preseasonWinner} vinder, får du <strong>{POINT_SYSTEM.PRESEASON_WINNER} point</strong> ekstra.
            </p>
          ) : (
            <p className="no-bonus-info">
              ❌ Du har gættet på {preseasonWinner} som vinder af Champions League 25/26 i fase 0 og de er ikke i finalen.
            </p>
          )}
        </div>
      )}
      
      <div className="final-prediction">
        <div className="final-match">
          <MatchComponent
            team1={finalMatch.home}
            team2={finalMatch.away}
            matchId={finalMatch.id}
            selectedWinner={finalPrediction}
            onWinnerSelect={onFinalPredictionChange}
            disabled={isFinalPredictionSaved || isPhase3Locked}
          />
        </div>
        
        {finalPrediction && (
          <div className="final-info">
            <p>Valgt finalevinder: <strong>{finalPrediction}</strong></p>
          </div>
        )}

        {!isFinalPredictionSaved && (
          <div className="save-guess-section">
            {hasFinalPrediction ? (
              <p><strong>Finale gæt er valgt!</strong></p>
            ) : (
              <p>Vælg en finalevinder for at gemme dit gæt</p>
            )}
            <Button 
              onClick={() => onSaveGroupGuess('')}
              title="Gem Finale Gæt"
              variant="contained"
              color="confirmation"
              disabled={!hasFinalPrediction || isPhase3Locked}
            />
          </div>
        )}
      </div>
      
      <PointSummary
        rules={[
          { text: `Gæt på det hold som du tror vinder finalen` },
          { text: `${POINT_SYSTEM.FINAL_WINNER} point for korrekt gæt på finalevinderen` },
          ...(preseasonWinner && isPreseasonWinnerInFinal ? [
            { text: `+${POINT_SYSTEM.PRESEASON_FINALIST} point hvis dit Phase 0 gæt (${preseasonWinner}) når finalen` },
            { text: `${POINT_SYSTEM.PRESEASON_WINNER} point hvis dit Phase 0 gæt (${preseasonWinner}) vinder finalen` }
          ] : [])
        ]}
      />
    </div>
  );
};

export default Phase3;
